import { useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';;
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../hooks/hooks";
import { selectCurrent } from "../../../redux/settings/selectors";
import JobList from "./job-list.component";

const TransportAgentHome = () => {
	const dispatch = useAppDispatch()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
	const [isLocation, setIsLocation] = useState<boolean>(false)
	// const captureLocation = () => {
	// 	const deviceDetails = {
	// 		userAgent: navigator.userAgent,
	// 		platform: navigator.platform,
	// 		language: navigator.language,
	// 		appVersion: navigator.appVersion,
	// 	};
	// 	console.log(deviceDetails)
	// 	if (navigator.geolocation) {
	// 		navigator.geolocation.getCurrentPosition(
	// 			(position) => {
	// 				const { latitude, longitude } = position.coords;
	// 				//dispatch(updateAgentLocation({
	// 				// 	payload: {
	// 				// deviceDetails: null;;
	// 				// 		latitude: latitude.toString(),
	// 				// 		longitude: longitude.toString(),
	// 				// 		isLatitudeSuccess: true,
	// 				// 		isLongitudeSuccess: true,
	// 				// 		isSuccess: true,
	// 				// 	}
	// 				// }));
	// 				console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);

	// 			},
	// 			(error) => {
	// 				switch (error.code) {
	// 					case error.PERMISSION_DENIED:
	// 						console.error("User denied the request for Geolocation.");
	// 						alert("Please enable location services for this app in your browser settings.iOS device (Settings > Privacy > Location Services)");
	// 						break;
	// 					case error.POSITION_UNAVAILABLE:
	// 						console.error("Location information is unavailable.");
	// 						alert("Location information is unavailable.");
	// 						break;
	// 					case error.TIMEOUT:
	// 						console.error("The request to get user location timed out.");
	// 						alert("The request to get user location timed out.");
	// 						break;

	// 				}
	// 			},
	// 			{
	// 				enableHighAccuracy: true,
	// 				maximumAge: 0
	// 			}
	// 		);
	// 		//dispatch(updateAgentLocation({ section, field, payload: { isEdit: false, isVerifyButtonVisible: false, isDeleteButtonVisible: true, isSuccess: true } }));

	// 	}
	// 	else {
	// 		console.error("Geolocation is not supported by this browser.");
	// 		alert("Geolocation is not supported by this browser.");
	// 	}
	// };
	// const handleGetFirebaseToken = () => {
	// 	getFirebaseToken()
	// 		.then((firebaseToken) => {
	// 			console.log(firebaseToken)
	// 			dispatch(pushNotifications.create({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/identity/platform-security/iam/subscribers`,entity:'pushNotifications',jsonData:{

	// 				Records: [
	// 					{
	// 							Context: {},
	// 							Message: {
	// 							  DCMToken: firebaseToken
	// 							}

	// 					  }
	// 				]

	// 			}}))
	// 		})
	// 		.catch((err) => console.error('An error occured while retrieving firebase token. ', err))
	// }
	// const handleStartLocation = () => {
	// 	setIsLocation(true)	
	// }
	// const handleEndLocation = () => {
	// 	setIsLocation(false)
	// }
	// useEffect(() => {
	// 	if(isLocation){
	// 	captureLocation()
	// 	 // Set up the interval to fetch data every 10 seconds (10000 ms)
	// 	 const intervalId = setInterval(captureLocation, 10000);
	// 	 return () => clearInterval(intervalId);
	// 	}
	// }, [isLocation])
	return (
		<div className="flex flex-col items-center px-4 pt-10 pb-20">

			<div className="flex justify-between items-center mb-6 w-full">
				<p className="text-2xl font-semibold mb-2 mb-0"><FormattedMessage id="app.heading" /></p>
			</div>
			<div className="w-full flex items-center flex-col  lg:flex-row p-1">
				<div className="flex flex-row items-center bg-indigo-200 justify-center h-36 w-full m-4 ">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="bg-indigo-200 w-1/3 h-12 fill-none mx-2">
						<circle cx="17" cy="18" r="2" stroke="currentColor" stroke-width="1" />
						<circle cx="7" cy="18" r="2" stroke="currentColor" stroke-width="1" />
						<path d="M11 17H15M13.5 7H14.4429C15.7533 7 16.4086 7 16.9641 7.31452C17.5196 7.62904 17.89 8.20972 18.6308 9.37107C19.1502 10.1854 19.6955 10.7765 20.4622 11.3024C21.2341 11.8318 21.6012 12.0906 21.8049 12.506C22 12.9038 22 13.375 22 14.3173C22 15.5596 22 16.1808 21.651 16.5755C21.636 16.5925 21.6207 16.609 21.6049 16.625C21.2375 17 20.6594 17 19.503 17H19" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
						<path d="M13 7L13.9942 9.48556C14.4813 10.7034 14.7249 11.3123 15.2328 11.6561C15.7407 12 16.3965 12 17.7081 12H21" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
						<path d="M4.86957 17C3.51684 17 2.84048 17 2.42024 16.5607C2 16.1213 2 15.4142 2 14V7C2 5.58579 2 4.87868 2.42024 4.43934C2.84048 4 3.51684 4 4.86957 4H10.1304C11.4832 4 12.1595 4 12.5798 4.43934C13 4.87868 13 5.58579 13 7V17H8.69565" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
					</svg>
					<div className="h-36 w-2/3 space-y-3 px-4  flex flex-col bg-white  items-start justify-center ">
						<div className="font-semibold text-3xl ">1,800</div>
						<div className="font-normal text-lg ">Total Shipments</div>
					</div>
				</div>
				<div className="flex flex-row items-center bg-green-200 justify-center h-36 w-full m-4 ">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="bg-green-200 w-1/3 h-12 mx-2  fill-none ">
						<path d="M7 18C5.17107 18.4117 4 19.0443 4 19.7537C4 20.9943 7.58172 22 12 22C16.4183 22 20 20.9943 20 19.7537C20 19.0443 18.8289 18.4117 17 18" stroke="currentColor" stroke-width="1" stroke-linecap="round" />
						<path d="M14.5 9C14.5 10.3807 13.3807 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9Z" stroke="currentColor" stroke-width="1" />
						<path d="M13.2574 17.4936C12.9201 17.8184 12.4693 18 12.0002 18C11.531 18 11.0802 17.8184 10.7429 17.4936C7.6543 14.5008 3.51519 11.1575 5.53371 6.30373C6.6251 3.67932 9.24494 2 12.0002 2C14.7554 2 17.3752 3.67933 18.4666 6.30373C20.4826 11.1514 16.3536 14.5111 13.2574 17.4936Z" stroke="currentColor" stroke-width="1" />
					</svg>
					<div className="h-36 w-2/3 space-y-3 px-4  flex flex-col bg-white  items-start px-2 justify-center">
						<div className="font-semibold text-3xl ">20</div>
						<div className="font-normal text-lg ">Active Shipments</div>
					</div>
				</div>
				<div className="flex flex-row items-center bg-yellow-200 justify-center h-36 w-full m-4 ">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="bg-yellow-200 w-1/3 h-12 mx-2  fill-none ">
						<path d="M21 7V12M3 7C3 10.0645 3 16.7742 3 17.1613C3 18.5438 4.94564 19.3657 8.83693 21.0095C10.4002 21.6698 11.1818 22 12 22L12 11.3548" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M15 19C15 19 15.875 19 16.75 21C16.75 21 19.5294 16 22 15" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M8.32592 9.69138L5.40472 8.27785C3.80157 7.5021 3 7.11423 3 6.5C3 5.88577 3.80157 5.4979 5.40472 4.72215L8.32592 3.30862C10.1288 2.43621 11.0303 2 12 2C12.9697 2 13.8712 2.4362 15.6741 3.30862L18.5953 4.72215C20.1984 5.4979 21 5.88577 21 6.5C21 7.11423 20.1984 7.5021 18.5953 8.27785L15.6741 9.69138C13.8712 10.5638 12.9697 11 12 11C11.0303 11 10.1288 10.5638 8.32592 9.69138Z" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M6 12L8 13" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M17 4L7 9" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
					</svg>
					<div className="h-36 w-2/3 space-y-3 px-4  flex flex-col bg-white  items-start justify-center">
						<div className="font-semibold text-3xl ">37</div>
						<div className="font-normal text-lg ">Delivered Today</div>
					</div>
				</div>
				<div className="flex flex-row items-center bg-orange-200 justify-center h-36 w-full m-4">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="bg-orange-200 w-1/3 h-12 mx-2  fill-none ">
						<path d="M19.5 19.5C19.5 20.8807 18.3807 22 17 22C15.6193 22 14.5 20.8807 14.5 19.5C14.5 18.1193 15.6193 17 17 17C18.3807 17 19.5 18.1193 19.5 19.5Z" stroke="currentColor" stroke-width="1" />
						<path d="M9.5 19.5C9.5 20.8807 8.38071 22 7 22C5.61929 22 4.5 20.8807 4.5 19.5C4.5 18.1193 5.61929 17 7 17C8.38071 17 9.5 18.1193 9.5 19.5Z" stroke="currentColor" stroke-width="1" />
						<path d="M14.5 19.5H9.5M19.5 19.5H20.2632C20.4831 19.5 20.5931 19.5 20.6855 19.4885C21.3669 19.4036 21.9036 18.8669 21.9885 18.1855C22 18.0931 22 17.9831 22 17.7632V15C22 11.4101 19.0899 8.5 15.5 8.5M11 6H12C13.4142 6 14.1213 6 14.5607 6.43934C15 6.87868 15 7.58579 15 9V17.5M2 12V17C2 17.9346 2 18.4019 2.20096 18.75C2.33261 18.978 2.52197 19.1674 2.75 19.299C3.09808 19.5 3.56538 19.5 4.5 19.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
						<path d="M7.85 7.85L6.5 6.95V4.7M2 6.5C2 8.98528 4.01472 11 6.5 11C8.98528 11 11 8.98528 11 6.5C11 4.01472 8.98528 2 6.5 2C4.01472 2 2 4.01472 2 6.5Z" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
					</svg>
					<div className="h-36 w-2/3 space-y-3 px-4 flex flex-col bg-white  items-start px-2 justify-center">
						<div className="font-semibold text-3xl ">3</div>
						<div className="font-normal text-lg ">Delayed</div>
					</div>
				</div>

			</div>

			<div className="w-full px-3">
				<div className="text-xl font-semibold mb-4">Recent Jobs</div>
				<div className="w-full bg-white border rounded-lg p-4">
					<JobList />
				</div>
			</div>
		</div>
	);
};

export default TransportAgentHome;
